import React, { useRef, useEffect } from "react";
import "./RichEditor.css";

const TOOLS = [
  { label: "B",      cmd: "bold"                               },
  { label: "I",      cmd: "italic"                             },
  { label: "U",      cmd: "underline"                          },
  { label: "H2",     cmd: "formatBlock", val: "h2"             },
  { label: "H3",     cmd: "formatBlock", val: "h3"             },
  { label: "• List", cmd: "insertUnorderedList"                },
  { label: "¶ Para", cmd: "formatBlock", val: "p"              },
  { label: "Link",   cmd: "createLink",  prompt: "Enter URL:"  },
];

export default function RichEditor({ value, onChange }) {
  const ref = useRef(null);

  // Set initial HTML once on mount — intentionally runs once.
  // We own the contentEditable DOM after mount; React must not overwrite it.
  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = value || "";
    }
  }, []); // empty deps = run once only

  const exec = (cmd, val = null) => {
    if (cmd === "createLink") {
      const url = window.prompt("Enter URL:");
      if (!url) return;
      document.execCommand(cmd, false, url);
    } else {
      document.execCommand(cmd, false, val);
    }
    ref.current.focus();
  };

  return (
    <div className="rich-editor-wrap">
      <div className="rich-editor-toolbar">
        {TOOLS.map((t) => (
          <button
            key={t.label}
            type="button"
            className="rich-editor-btn"
            title={t.label}
            onMouseDown={(e) => {
              e.preventDefault();
              exec(t.cmd, t.val || null);
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div
        ref={ref}
        className="rich-editor-body"
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
      />
    </div>
  );
}
